import { CityBackground } from "@/components/landing/CityBackground";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Storefront } from "@/components/landing/Storefront";
import { CommandCenter } from "@/components/landing/CommandCenter";
import { GrowthEngine } from "@/components/landing/GrowthEngine";
import { Customers } from "@/components/landing/Customers";
import { Advantage } from "@/components/landing/Advantage";
import { DownloadCTA } from "@/components/landing/DownloadCTA";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="relative">
      <CityBackground />
      <div className="noise-overlay" />
      <div className="relative z-10">
        <Navbar />
        <Hero />
        <Storefront />
        <CommandCenter />
        <GrowthEngine />
        <Customers />
        <Advantage />
        <DownloadCTA />
        <Footer />
      </div>
    </main>
  );
}
